export default __webpack_public_path__ + "static/media/employ.c389385e.svg";